import classNames from 'classnames'
import React from 'react'

import { FinancialBeautifiedValue } from 'partner360/components/financialBeautifiedValue/FinancialBeautifiedValue'

import { isTotalRowsColumn } from '../../../helpers/isTotalRowsColumn'
import styles from '../../../Revenue.module.scss'

interface IProps {
  classes?: { [p: string]: boolean }
  value: string | number | undefined | null
  keyValue: string
}

export const RenderFieldValue = ({ classes, value, keyValue }: IProps) => {
  return (
    <FinancialBeautifiedValue
      value={value}
      className={classNames(styles.textItem, styles.alignColumns, {
        [classNames(styles['total'], styles.totalColumn, styles.column)]:
          isTotalRowsColumn(keyValue),
        ...(classes || {}),
      })}
    />
  )
}
